import React from "react";
import Client from "../../ws/client.js";
class Ws extends React.Component {
  constructor(props) {
    super(props);
    this.objectIdList = {
      kpiSales: "nfdCbuc",
      topFiveSales: "Lvwjt",
      salescombinendChart: "TmWTt",
      productSales: "VpzzQM",
      branchSales: "fsRhKd",
      channelSales: "ucANs",
      resumeSales: "nfdCbuc",
      trend: "jpjWA",
      salesSpreadSheet: "ryBDgC",

      topFiveInventory: "erazM",
      inventoryStatus: "hMkPK",
      inventoryProducts: "9b5a3804-97ec-4286-947d-61f9cc2b1ed4",
      kpiInventory: "tjJgDEu"
    };
    this.client = new Client("http://192.168.101.101:8082");
    this.conStatus = false;
    this.state = {
      connected: false,
      fieldList: [],
      years: [],
      months: [],
      products: [],
      branches: [],
      clients: []
    };
  }
  componentDidMount() {
    this.connect();
  }

  getSelections = () => {
    return new Promise((resolve, reject) => {
      this.client.action(
        "getSelections",
        { fieldList: this.state.fieldList },
        response => {
          resolve(response);
        }
      );
    });
  };
  clearSelections = () => {
    return new Promise((resolve, reject) => {
      this.client.action("clearAllSelections", () => {
        this.state.fieldList = [];
        resolve();
      });
    });
  };

  setFieldList = data => {
    let splitData = data.split("-");
    let name = splitData[0];
    let value = splitData[1];
    let fields = { name: name, value: [value], state: 1 };
    this.setState({
      fieldList: this.state.fieldList.push(fields)
    });
  };

  getObjectId = (object, section) => {
    return new Promise((resolve, reject) => {
      this.client.action(
        "getObjectById",
        { objectId: object, app: section },
        response => {
          resolve(response);
        }
      );
    });
  };

  getSalesResume = user => {
    return new Promise((resolve, reject) => {
      this.client.action(
        "getObjectById",
        { objectId: this.objectIdList.resumeSales },
        response => {
          resolve(response);
        }
      );
    });
  };

  connect = async (action, object) => {
    let data;
    if (!this.conStatus) {
      await this.client.connect(async () => {});
      this.conStatus = true;
    }
    switch (action) {
      case "getSelections":
        data = await this.getSelections();
        break;
      case "getObjectId":
        data = await this.getObjectId(object);
        break;
      case "getSalesResume":
        data = await this.getObjectId(this.objectIdList.topFiveSales, "ventas");
        break;
      case "getProductSales":
        data = await this.getObjectId(this.objectIdList.productSales, "ventas");
        break;
      case "getBranchSales":
        data = await this.getObjectId(this.objectIdList.branchSales, "ventas");
        break;
      case "getChannelSales":
        data = await this.getObjectId(this.objectIdList.channelSales, "ventas");
        break;
      case "getTopFiveSales":
        data = await this.getObjectId(this.objectIdList.topFiveSales, "ventas");
        break;
      case "getKpiSales":
        data = await this.getObjectId(this.objectIdList.kpiSales, "ventas");
        break;
      case "getTopFiveInventory":
        data = await this.getObjectId(
          this.objectIdList.topFiveInventory,
          "inventario"
        );
        break;
      case "getInventoryStatus":
        data = await this.getObjectId(
          this.objectIdList.inventoryStatus,
          "inventario"
        );
        break;
      case "getProductInventory":
        data = await this.getObjectId(
          this.objectIdList.inventoryProducts,
          "inventario"
        );
        break;
      case "getSalesCombinedChart":
        data = await this.getObjectId(
          this.objectIdList.salescombinendChart,
          "ventas"
        );
        break;

      case "getKpiInventory":
        data = await this.getObjectId(
          this.objectIdList.kpiInventory,
          "inventario"
        );
        break;
      case "setSelections":
        await this.setFieldList(object);
        break;
      case "clearSelections":
        await this.clearSelections();
        break;
      default:
        console.log("no action called");
        break;
    }
    return data;
  };
}

export default Ws;
